// extracted by mini-css-extract-plugin
module.exports = {"color":"GplHFn","oldColor":"x_HXFF","dropdown":"EHZqPm","oldDropdown":"sX06Sd"};